import { useInfiniteQuery as u } from "react-query";
import { useMe as g } from "./useMe.js";
import { useBusinessModalContext as m } from "../BusinessModalContext.js";
import { useGroupsQueryParams as c } from "./queryParams/groups/useGroupsQueryParams.js";
const d = "groups", y = (a = {}, p = {}) => {
  const {
    apiClient: i
  } = m(), {
    data: e
  } = g(), r = c();
  !a.org_id && e?.org_id && (r.org_id = e.org_id);
  const s = u([d, r], ({
    pageParam: o = 1
  }) => i.groups.getSections({
    ...r,
    page: o
  }), {
    getNextPageParam: (o) => o.page < o.max_page ? o.page + 1 : void 0,
    ...p
  }), t = s.data?.pages?.map(({
    sections: o
  }) => o).flat(), n = t?.map(({
    groups: o
  }) => o).flat();
  return {
    query: s,
    sections: t,
    groups: n
  };
};
export {
  d as GROUPS,
  y as useGroups
};
